/* eslint-disable @typescript-eslint/no-explicit-any */
// packages
import { SubmitHandler, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import va from "@vercel/analytics";

// components
import { Button } from "@components/Button/Button";
// import Input from "@components/Input/Input";
import api from "@src/utils";
import apiRoutes from "@/src/apiRoutes";
import { toast } from "sonner";
import AuthInput from "@/src/components/AuthInput";
import { ArrowLeft } from "lucide-react";

const formState = z.object({
  email: z.string().email({ message: "Enter a valid email address" }),
});

const ForgotPassword = () => {
  type resetType = z.infer<typeof formState>;
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<resetType>({
    resolver: zodResolver(formState),
  });

  const reset = async (input: resetType) => {
    const res = await api.post(apiRoutes.passwordResetExternal, {
      type: "request",
      email: input?.email,
    });
    return res.data;
  };

  const { mutate: mutateForgot, isLoading } = useMutation({
    mutationKey: ["forgot_password"],
    mutationFn: reset,
    onSuccess: (data: any) => {
      if (data?.success) {
        va.track("Forgot Password");
        navigate(`/auth/reset/${getValues().email}/`);
        toast.success(data?.info);
      } else {
        toast.warning(data?.info);
      }
    },
  });

  const onSubmit: SubmitHandler<resetType> = async (data) => {
    mutateForgot(data);
  };

  return (
    <div className="mt-5">
      <h1 className="font-semibold text-2xl text-center tracking-tight">
        Reset Password
      </h1>
      <div className="flex-1 h-full flex flex-col items-center">
        {/* <h2 className="w-full text-sm ">
          Already have an account?{" "}
          <Link className="text-blue-600" to="/auth/">
            Login here
          </Link>
        </h2> */}
        <div className="w-full">
          <form
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
            className=" grid grid-cols-1 gap-3 mt-2"
          >
            <AuthInput
              errors={errors?.email?.message}
              label="Email"
              id="email"
              type="email"
              placeholder="Email"
              {...register("email", { required: true })}
            />
            <Button
              className="md:py-4 py-3"
              variant={"primary"}
              loading={isLoading}
              type="submit"
              // title="Submit"
            >
              Submit
            </Button>
          </form>
        </div>
        <div className="w-full flex justify-center mt-5">
          <Link to={"/"} className="flex items-center gap-1 cursor-pointer">
            <ArrowLeft className="h-5 w-5 text-blue-500" />
            <span
              // onClick={prevStep}
              className="text-center text-blue-500 font-semibold text-sm"
            >
              Go back
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
